import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

const mapStateToProps = state => ({
  cycleLegs: state.api.availabilityCycleLegs.data
});

const CycleLegs = ({ cycleLegs, objectId, permissions }) => {
  /*
   ** @description Prepare data for API
   ** @param leg object
   ** @param cycle_id number
   ** @param order number
   ** @return object
   */
  const handlePrepareData = ({ leg, cycle_id, order }) => ({
    cycle_id,
    leg_id: leg.key,
    order: order || cycleLegs.count + 1
  });

  return (
    <Inner
      canAdmin={permissions.CanAdminAvailabilities()
        .hasPermissions()}
      reducer={{
        item: REDUCER_KEY.availabilityCycleLeg,
        list: REDUCER_KEY.availabilityCycleLegs
      }}
      config={{
        ...config,
        list: {
          ...config.list,
          filters: {
            cycle: [objectId]
          }
        },
        detail: {
          ...config.detail,
          parent: {
            cycle_id: objectId
          }
        }
      }}
      onPrepareData={handlePrepareData}
      defaultSize="150px"
      scroll={{
        x: 800,
        y: '100%'
      }}
      messaging={{
        delete: {
          disabled: () => 'Item Disabled.',
          failure: error => `Delete Failed. ${error}`,
          success: () => 'Delete Successful.'
        },
        save: {
          failure: () => 'Saving failed',
          success: () => 'Saving was successful'
        }
      }}
      permissions={permissions}
    />
  );
};

CycleLegs.propTypes = {
  cycleLegs: PropTypes.object,
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

CycleLegs.defaultProps = {
  cycleLegs: {},
  objectId: null
};

export default connect(mapStateToProps, null)(CycleLegs);
